import React from 'react';
import {View} from 'react-native';

function TestCrash() {
    return <View />;
}

export default TestCrash;
